<template>
  <div style="height: 100%">
    <vue-dropzone ref="filedropzone"
      :id="'filedropzone'+id"
      :options="dropzoneOptions"
      @vdropzone-file-added="(file)=>acceptFile(file)"
      @vdropzone-processing="(file)=>processFile(file)"
      @vdropzone-sending="(file, xhr)=>sendingFile(file, xhr)"
      @vdropzone-complete="(file) =>successFile(file)"
      @vdropzone-error="dropzoneError"
      :additional-classes="additionalClasses" />
  </div>
</template>
<script>
import VueDropzone from '@/components/VueDropzone'
import QuoteService from '@/views/quote/QuoteService'

export default {
  name: 'FileDropZone',
  components: {
    VueDropzone
  },
  props: {
    quoteId: {
      type: String
    },
    quoteAttachmentCategoryId: {
      type: String
    },
    previewsContainer: {
      type: String,
      default: null
    },
    defaultSize: {
      type: Number,
      default: 128
    },
    additionalClasses: {
      type: String,
      default: ''
    },
    maxFileSizeMb: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      id: null,
      dropzoneOptions: {
        url: '/',
        dictDefaultMessage: 'Drop files here or click to upload',
        autoProcessQueue: false,
        thumbnailWidth: this.defaultSize,
        thumbnailHeight: this.defaultSize,
        maxFilesize: this.maxFileSizeMb,
        resizeWidth: 800,
        acceptedFiles: 'image/jpeg,image/jpg,image/png,image/gif,image/bmp,application/pdf',
        previewsContainer: this.previewsContainer
      }
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.id = this._uid + ''
  },
  methods: {
    async acceptFile(file) {
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/bmp', 'image/webp', 'application/pdf']
      if (!allowedTypes.includes(file.type)) {
        const errorMsg = 'Unsupported file type'
        file.accepted = false
        file.errorMessage = errorMsg
        this.$refs.filedropzone.dropzone.emit('error', file, errorMsg)
        this.$refs.filedropzone.dropzone.emit('complete', file)
        return
      }
      // Check file size (maxFilesize is in MB, file.size is in bytes)
      const maxFileSizeInBytes = this.dropzoneOptions.maxFilesize * 1024 * 1024
      if (file.size > maxFileSizeInBytes) {
        const errorMsg = `File size must not exceed ${this.dropzoneOptions.maxFilesize}MB`
        file.accepted = false
        file.errorMessage = errorMsg
        this.$refs.filedropzone.dropzone.emit('error', file, errorMsg)
        this.$refs.filedropzone.dropzone.emit('complete', file)
        return
      }
      this.$showSpinner()
      let packet = (await QuoteService.getQuoteAttachmentUploadUrl(this.quoteId)).data
      file.uploadURL = packet.url
      file.guid = packet.guid
      this.$refs.filedropzone.processFile(file)
    },
    dropzoneQueueComplete() {
      this.$hideSpinner && this.$hideSpinner()
      this.$emit('queue-complete')
    },
    async processFile(file) {
      this.$refs.filedropzone.changeUrl(file.uploadURL)
    },
    sendingFile(file, xhr) {
      console.log(file, xhr)
    },
    async successFile(file) {
      await QuoteService.setupQuoteAttachment(this.quoteId, this.quoteAttachmentCategoryId, file.guid, file.name)
      this.$emit('image-uploaded', {})
      this.$hideSpinner()
    },
    dropzoneError(file, message, xhr) {
    },
    clearAllFiles() {
      if (this.$refs.filedropzone && typeof this.$refs.filedropzone.removeAllFiles === 'function') {
        this.$refs.filedropzone.removeAllFiles(true)
      }
    }
  }
}
</script>